<template>
  <div>
    <payments-component></payments-component>
  </div>
</template>

<script>
import PaymentsComponent from "@/components/PaymentsComponent";

export default {
  components: {
    PaymentsComponent
  }
};
</script>

<style lang="scss" scoped>
</style>